import { theme } from '@/styles/theme';

export const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9998,
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  background: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: '#000000',
    opacity: 0.24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '340px',
    padding: '16px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    zIndex: 9999,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  illustrationContent: {
    marginTop: 27,
  },
  illustrationImage: {
    width: 115,
    height: 90,
  },
  titleBox: {
    marginTop: 12,
    marginBottom: 12,
  },
  title: {
    fontSize: '1.8rem',
    textAlign: 'center',
    color: theme.palette.popup.dark,
    fontWeight: 600,
  },
  descriptionBox: {
    display: 'flex',
    width: '100%',
    maxWidth: '354px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    fontSize: '1.2rem',
    textAlign: 'center',
    color: theme.palette.popup.light,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonContent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 2,
    marginBottom: 2,
    gap: 1,
  },
  closeBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'right',
  },
};
